import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    border: `1px solid ${theme.palette.grey[300]}`,
    padding: '24px 24px',
    borderRadius: 8
  },
  rootCashBalance: {
    backgroundColor: theme.palette.grey[200],
    border: 'none'
  },
  topSection: {
    display: 'grid',
    gridTemplateColumns: '1fr 8fr',
    gap: 4
  },
  titleAndBalance: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    marginLeft: 4
  },
  subTitle: {
    marginTop: 48
  },
  title: {
    color: theme.palette.grey[500],
    fontSize: 14,
    weight: 500
  },
  loadingSpinner: {
    marginTop: '0.5rem', // Adjust margin as needed
    color: 'gray' // Change color if needed
  }
}))

export default useStyles
